module.exports = __webpack_public_path__ + "static/media/alert-watermark.2611f486.svg";